import { createBaseAction } from '@essent/common';

export const startChat = createBaseAction<{ login: boolean }>(
  '[Chatting] Start chat'
);
